import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-test-id"]

import { usePageStore } from '@/store';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Divider',
  props: {
    outerClass: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const outerClass = `${props.outerClass ?? ''} ${props.rendering?.params?.Styles ?? ''}`.trim();
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(props.rendering);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border-b border-solid border-racq-white my-2", _unref(outerClass)]),
    style: _normalizeStyle(_unref(inlineStyle)),
    "data-test-id": _unref(dataTestId)
  }, null, 14, _hoisted_1))
}
}

})